<header>
  <div class="sistemas-header">
    <img class="sistemas-img" src="../assets/img/sistemas.png">
    <span class="sistemas">Sistemas</span>
  </div>
</header>

<div *ngIf="showRedAlert" class="red-alert">
  ESTE É UM SISTEMA DE TESTES, NÃO O UTILIZE PARA OUTRO FIM
</div>

<main>
  <ng-container *ngFor="let sistema of sistemas">
    <mat-card class="sistemas-card">
      <mat-card-title class="sistemas-center sistemas-title" [ngClass]="sistema.old ? 'sistemas-old' : 'sistemas-new'">{{sistema.nome}}</mat-card-title>
      <mat-card-subtitle class="sistemas-center"></mat-card-subtitle>
      <mat-card-content class="sistemas-center sistemas-content">{{sistema.desc}}</mat-card-content>
      <mat-card-actions class="sistemas-center sistemas-actions">
        <a mat-raised-button color="primary" [ngClass]="sistema.old ? 'sistemas-old' : 'sistemas-new'" [disabled]="sistema.inativo" href="{{production ? sistema.linkProd : sistema.linkStag}}">Acessar</a>
      </mat-card-actions>
    </mat-card>
  </ng-container>
</main>

<footer>
  SISTEMAS - ERP
</footer>